/**
 * OPAS varsayılan yazı tipi: Outfit (next/font/local).
 */
import localFont from 'next/font/local'

export const outfit = localFont({
  src: [
    { path: '../../public/fonts/outfit-latin-400-normal.woff2', weight: '400' },
    { path: '../../public/fonts/outfit-latin-700-normal.woff2', weight: '700' },
    // Latin Extended: ğ, ş, ı, ü, ö, ç, İ — aksi halde tarayıcı fallback font kullanır
    { path: '../../public/fonts/outfit-latin-ext-400-normal.woff2', weight: '400' },
    { path: '../../public/fonts/outfit-latin-ext-700-normal.woff2', weight: '700' },
  ],
  display: 'swap',
  fallback: ['ui-sans-serif', 'system-ui', 'sans-serif'],
})

export const outfitFontFamily = outfit.style.fontFamily

/** Outfit değişken font — ince/kalın marka yazıları (ör. MEDOPAS) */
export const outfitVariable = localFont({
  src: [{ path: '../../public/fonts/Outfit-Variable.ttf', style: 'normal' }],
  display: 'swap',
  fallback: ['ui-sans-serif', 'system-ui', 'sans-serif'],
})

/** @deprecated Zalando kaldırıldı — geriye dönük importlar için Outfit alias */
export const zalandoSansFontFamily = outfitFontFamily
/** @deprecated */
export const zalandoSans = outfit

export const montserrat = localFont({
  src: [
    { path: '../../public/fonts/montserrat-latin-400-normal.woff2', weight: '400' },
    { path: '../../public/fonts/montserrat-latin-600-normal.woff2', weight: '600' },
    { path: '../../public/fonts/montserrat-latin-700-normal.woff2', weight: '700' },
    { path: '../../public/fonts/montserrat-latin-ext-400-normal.woff2', weight: '400' },
    { path: '../../public/fonts/montserrat-latin-ext-400-normal.woff2', weight: '600' },
    { path: '../../public/fonts/montserrat-latin-ext-400-normal.woff2', weight: '700' },
  ],
  variable: '--font-montserrat',
  display: 'swap',
  fallback: ['ui-sans-serif', 'system-ui', 'sans-serif'],
})

export const jetbrainsMono = localFont({
  src: [{ path: '../../public/fonts/jetbrains-mono-latin-400-normal.woff2', weight: '400' }],
  display: 'swap',
  fallback: ['ui-sans-serif', 'system-ui', 'sans-serif'],
})

/** @deprecated Arayüzde Outfit kullanın */
export const spaceMono = outfit

export const rajdhani = localFont({
  src: [
    { path: '../../public/fonts/rajdhani-latin-400-normal.woff2', weight: '400' },
    { path: '../../public/fonts/rajdhani-latin-700-normal.woff2', weight: '700' },
  ],
  display: 'swap',
  fallback: ['ui-sans-serif', 'system-ui', 'sans-serif'],
})
